import { routes } from 'types/routes.ts'
import styles from 'pages/app/overview/Overview.module.scss'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton.tsx'
import OverviewCard from 'pages/app/overview/overview-cards/OverviewCard.tsx'
import { useStoreSelector } from 'hooks/store.ts'
import { useGetLanguage } from 'hooks/use-get-language'
import { useGetActiveReferralActionQuery } from 'store/queries/cms-api'
import { useTranslation } from 'react-i18next'
import { REFERRAL_AMOUNT_GIVE, REFERRAL_AMOUNT_RECEIVE } from 'constants/referral.ts'
import { useGetContactReferralsQuery } from 'store/queries/bolt-api/contacts'
import { forwardRef } from 'react'
import { Tag } from '@boltenergy-be/design-system'

const ReferralOverviewCard = forwardRef<HTMLElement>((_, ref) => {
  // Redux store
  const { contact } = useStoreSelector((store) => store.contact)

  // i18n
  const { t } = useTranslation(['overview', 'common'])
  const language = useGetLanguage()

  // Redux queries
  const { data: activeAction, isLoading: loadingAction } = useGetActiveReferralActionQuery({ language }, { skip: true }) // Skipped because there is no active referral action
  const { data: referrals, isLoading: loadingReferrals } = useGetContactReferralsQuery(contact?.sfId || '', { skip: !contact })
  const isLoading = loadingAction || loadingReferrals

  // Constants
  const amountGive = activeAction?.reduction || REFERRAL_AMOUNT_GIVE
  const amountReceive = activeAction?.reduction || REFERRAL_AMOUNT_RECEIVE

  return (
    <OverviewCard
      ref={ref}
      isLoading={isLoading}
      button={{ label: t(($) => $.referral.button[referrals?.length ? 'hasReferrals' : 'default']), href: routes.REFERRAL_INFO }}
      image={
        isLoading
          ? { loading: isLoading }
          : {
              className: styles['referral-image-default'],
              publicId: 'website/referral/charlotte-kelly',
              alt: 'Invite a friend'
            }
      }
      color="soft"
    >
      {isLoading ? (
        <>
          <LoadingSkeleton.Title />
          <LoadingSkeleton.Paragraph lines={2} />
        </>
      ) : (
        <>
          {activeAction && (
            <Tag type="informative" size="small">
              {activeAction?.websiteHero?.tag ||
                t(($) => $.temporaryAction, {
                  ns: 'common'
                })}
            </Tag>
          )}
          <OverviewCard.Title>
            {activeAction
              ? activeAction?.websiteHero?.title
              : referrals?.length
                ? t(($) => $.referral.title.hasReferrals, {
                    count: referrals.length
                  })
                : t(($) => $.referral.title.default, {
                    amountGive: amountGive,
                    amountReceive: amountReceive
                  })}
          </OverviewCard.Title>
        </>
      )}
    </OverviewCard>
  )
})

ReferralOverviewCard.displayName = 'ReferralOverviewCard'

export default ReferralOverviewCard
